import type { ReactNode } from 'react';
import { Popover as P } from '@base-ui/react/popover';
import { cn } from '../lib/utils';

/**
 * Non-menu floating panel (e.g. the notification inbox): focus moves into the popup and returns
 * to the trigger on close; Escape and outside clicks close it. Same DESIGN.md floating layer as
 * `MenuPopup`.
 */
export const PopoverRoot = P.Root;
export const PopoverTrigger = P.Trigger;
export const PopoverTitle = P.Title;
export const PopoverClose = P.Close;

export function PopoverPopup({
  children,
  align = 'end',
  className,
  'aria-label': ariaLabel,
}: {
  children: ReactNode;
  align?: 'start' | 'center' | 'end';
  className?: string;
  'aria-label'?: string;
}) {
  return (
    <P.Portal>
      <P.Positioner
        className="z-50 outline-none"
        align={align}
        sideOffset={6}
        collisionPadding={16}
      >
        <P.Popup
          aria-label={ariaLabel}
          className={cn(
            'max-h-(--available-height) w-[min(24rem,calc(100vw-2rem))] overflow-y-auto rounded-lg border border-[var(--line)] bg-[var(--surface)] text-sm text-[var(--ink)] shadow-[var(--shadow-tooltip)] outline-none',
            className,
          )}
        >
          {children}
        </P.Popup>
      </P.Positioner>
    </P.Portal>
  );
}
